export default __webpack_public_path__ + "static/menu-icon-opened-8c3b69cb93cc55aa5ff268909d666057.png";